const USER_INFO = "step_user_info";
const storage = window.localStorage;
const CAPTCHA = "step_captcha";
let userInfo = null;
let authList;
export default {
  login(obj) {
    storage.setItem(USER_INFO, JSON.stringify(obj));
    userInfo = obj;
  },
  logout() {
    userInfo = null;
    this.clearAllStorage();
  },
  clearAllStorage() {
    // 这里添加一个校验，校验字符串中是否包含_年-月-日的格式
    const pattern = /_(\d{4})-(\d{2})-(\d{2})$/;
    // 保存需要保留的项
    const removeItem = [];
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (!pattern.test(key)) {
        removeItem.push(key);
      }
    }
    for (let key of removeItem) {
      storage.removeItem(key);
    }
  },
  isLogin() {
    return !!this.getToken();
  },
  getUserInfo() {
    if (!userInfo) {
      if (storage.getItem(USER_INFO) !== "undefined") {
        userInfo = JSON.parse(storage.getItem(USER_INFO));
      }
    }
    return userInfo || {};
  },
  getToken() {
    return this.getUserInfo().token;
  },
  getUserId() {
    return this.getUserInfo().userId;
  },
  getUserName() {
    return this.getUserInfo().userName;
  },
  getName() {
    return this.getUserInfo().name;
  },
  getAuth() {
    return this.getUserInfo().navItemList;
  },
  getAuthString() {
    return this.getUserInfo().userAuthority;
  },
  hasAuth(functionID) {
    try {
      authList = this.getUserInfo().navItemList;
      for (let item of authList) {
        if (item.functionID === functionID) {
          return true;
        }
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  },
  getUserType() {
    // 0：管理员 1： 内部用户  2： 外部用户  3：高级用户
    return this.getUserInfo().userType;
  },
  getLoginType() {
    return this.getUserInfo().loginType;
  },
  getWorkshopNo() {
    return this.getUserInfo().workshopNo;
  },
  isShowCaptcha() {
      return storage.getItem(CAPTCHA) === "true";
  },
  showCaptcha() {
      storage.setItem(CAPTCHA, "true");
  },
  hideCaptcha() {
      storage.setItem(CAPTCHA, "false");
  },
};
